import { useQuery } from '@apollo/client';
import { GET_SINGLE_CLAIM } from 'graphql/secure/queries';
import { useParams } from 'react-router-dom';
import { ImpactClaim } from 'FeatureModules/Request/types/impactClaim.types';
import { TRouteParamsWithId } from 'types/router.types';

const useImpactClaim = () => {
  const { id: paramId } = useParams<TRouteParamsWithId>();

  const { data, loading, error } = useQuery<{
    impactClaim: ImpactClaim;
  }>(GET_SINGLE_CLAIM, {
    variables: {
      id: paramId,
      lang: 'en',
      requestStatus: ['REQUESTED'],
    },
  });

  return {
    impactClaim: data?.impactClaim,
    loading,
    error,
  };
};

export default useImpactClaim;
